import { ApiProvider } from '@/provider/ApiProvider';
import USER_TYPES from '@/provider/constants';

type UserLike = { type?: number | string | null } | null | undefined;

export const getUserType = (user?: UserLike): number => {
  const type = user?.type ?? ApiProvider.returnUserData()?.type;
  return Number(type || 0);
};

export const isGlobalUser = (userType = getUserType()) => userType === USER_TYPES.GLOBAL;

export const isBrandUser = (userType = getUserType()) => userType === USER_TYPES.BRAND;

export const isPropertyUser = (userType = getUserType()) => userType === USER_TYPES.PROPERTY;

export const isAgencyUser = (userType = getUserType()) => userType === USER_TYPES.AGENCY;

export const isRightHolderUser = (userType = getUserType()) =>
  isPropertyUser(userType) || isAgencyUser(userType);

export const shouldShowPropertySelector = (userType = getUserType()) => isRightHolderUser(userType);

export const shouldShowBrandSelector = (userType = getUserType()) =>
  [USER_TYPES.GLOBAL, USER_TYPES.BRAND, USER_TYPES.PROPERTY, USER_TYPES.AGENCY].includes(userType) ||
  !userType;

export const getStoredPropertyId = () => localStorage.getItem('property_id') || null;

export const resolveRightHolderPropertyId = (propertyId?: string | number | null) => {
  if (propertyId != null && propertyId !== '') {
    return String(propertyId);
  }

  return getStoredPropertyId();
};

export const shouldShowBrandPortfolioPartnerDetails = (propertyId?: string | number | null) =>
  isRightHolderUser() && Boolean(resolveRightHolderPropertyId(propertyId));

export { USER_TYPES };
